<nav
  class="dropdown-menu"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-expanded]="isShowing()"
  (clickOutside)="close($event)"
  [openState]="isShowing()"
  [invalidTargetNames]="invalidTargetNames()"
>
  <div class="dropdown-menu__opener" [class.dropdown-menu__opener--showing]="isShowing()">
    <ng-container *ngTemplateOutlet="openerTemplate()" />
  </div>
  <div
    class="dropdown-menu__menu"
    [class.dropdown-menu__menu--showing]="isShowing()"
    [class.dropdown-menu__menu--showing--left]="isLeftPositioned()"
  >
    <ftr-dropdown-menu-items
      (hide)="close()"
      [menuItems]="menuItems()"
      [routerLinkActiveExact]="routerLinkActiveExact()"
    />
  </div>
</nav>
